<template>
    <div class="for-u-container">
        <Card>
            <Tabs v-model="activeTab" @on-click="handleTabChange">
                <TabPane v-for="tab in tabs" :key="tab.value" :label="tab.label" :name="tab.value" />
            </Tabs>
            <div class="search">
                <!-- <Input v-model="palsyName" placeholder="搜索剧集名称" clearable style="width: 200px;" /> -->
                 <playCascader ref="playRef" :value="playIds ? playIds.split(',') : []" :langId="activeTab"
                    @update:value="playIds = $event.join(',')" />
                <Button type="primary" @click="handleSearch">搜索</Button>
                <Button  @click="handleReset">重置</Button>
            </div>

            <div class="table-container">
                <div v-if="loading" class="loading-overlay">
                    <div class="loading-spinner"></div>
                </div>
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="col-drag">排序</th>
                            <th class="col-top">置顶</th>
                            <th class="col-chinese-name">剧集中文名称</th>
                            <th class="col-episode-name">剧集名称</th>
                            <th class="col-play-count">近30天播放量</th>
                        </tr>
                    </thead>
                    <draggable v-model="currentData" :handle="'.drag-icon'" tag="tbody" item-key="id" animation="150"
                        ghost-class="sortable-ghost"  @end="handleDragEnd">
                        <tr :key="element.id" v-for="element in currentData">
                            <td class="col-drag">
                                <span v-if="element.istop === 1" class="drag-icon">
                                    <Icon type="ios-menu" />
                                </span>
                                <span v-else class="empty-drag">-
                                </span>
                            </td>
                            <td class="col-top">
                                <Button :type="element.istop === 1 ? 'primary' : 'default'" size="small"
                                    @click="handleTop(element)">
                                    {{ element.istop === 1 ? '取消置顶' : '置顶' }}
                                </Button>
                            </td>
                            <td class="col-chinese-name">
                                  <button class="btn-tag" v-if="element.istop === 1">置顶</button>
                                  {{ element.playChineseName }}
                                </td>
                            <td class="col-episode-name">{{ element.playName }}</td>
                            <td class="col-play-count" style="color: #409eff">{{ formatPlayCount(element.amountOfPlay) }}</td>
                        </tr>
                    </draggable>
                   <tr v-if="currentData.length === 0" class="no-data">
                        <td colspan="7" style="text-align: center; padding: 20px 0;">
                            暂无数据
                        </td>
                    </tr>
                </table>
            </div>

            <div class="pagination">
                <Pages :page="pageObj" :func="handlePageChange" />
            </div>
        </Card>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import Pages from '@/components/pages'
import { getLangList } from '../../api/lang'
import { getMinisForUPage, updateMinisForUUpdate } from '../../api/for-u'
import playCascader from '../play/playCascader.vue'
export default {
    name: 'ForUIndex',
    components: {
        draggable,
        Pages,
        playCascader
    },
    data() {
        return {
            playIds: '',
            activeTab: '',
            tabs: [],
            activeLanguage: 'english',
            palsyName: '',
            loading: false,
            currentData: [],
            pageObj: {
                current: 1,
                size: 10,
                total: 0
            },

            mockDataByLanguage: {
                english: [
                    { id: 1, chineseName: '月光篇', episodeName: 'Love Story', playCount: '40.8万', isTop: true, sort: 1 },
                    { id: 2, chineseName: '月光篇', episodeName: 'Love Story', playCount: '40.8万', isTop: true, sort: 2 },
                    { id: 3, chineseName: '风城巷', episodeName: 'Promise', playCount: '48.1万', isTop: true, sort: 3 },
                    { id: 4, chineseName: '云归辞', episodeName: 'Sweetheart', playCount: '47.0万', isTop: true, sort: 4 },
                    { id: 5, chineseName: '云情绵', episodeName: 'Memory', playCount: '43.8万', isTop: true, sort: 5 },
                    { id: 6, chineseName: '山时光', episodeName: 'HeartBeat', playCount: '36.7万', isTop: false, sort: 6 },
                    { id: 7, chineseName: '春情愫', episodeName: 'Promise', playCount: '36.1万', isTop: false, sort: 7 },
                    { id: 8, chineseName: '情绵绵', episodeName: 'Forever', playCount: '33.3万', isTop: false, sort: 8 },
                    { id: 9, chineseName: '星语篇', episodeName: 'Promise', playCount: '33.2万', isTop: false, sort: 9 },
                    { id: 10, chineseName: '情绵绵', episodeName: 'Promise', playCount: '23.9万', isTop: false, sort: 10 },
                    { id: 11, chineseName: '星年华', episodeName: 'Promise', playCount: '22.2万', isTop: false, sort: 11 },
                    { id: 12, chineseName: '风华华', episodeName: 'Sunshine', playCount: '16.2万', isTop: false, sort: 12 },
                ],
                thai: [
                    { id: 101, chineseName: '泰剧1', episodeName: 'Thai Drama 1', playCount: '35.2万', isTop: true, sort: 1 },
                    { id: 102, chineseName: '泰剧2', episodeName: 'Thai Drama 2', playCount: '28.6万', isTop: true, sort: 2 },
                    { id: 103, chineseName: '泰剧3', episodeName: 'Thai Drama 3', playCount: '22.4万', isTop: false, sort: 3 },
                    { id: 104, chineseName: '泰剧4', episodeName: 'Thai Drama 4', playCount: '18.9万', isTop: false, sort: 4 },
                ],
                indonesian: [
                    { id: 201, chineseName: '印尼剧1', episodeName: 'Indo Drama 1', playCount: '42.1万', isTop: true, sort: 1 },
                    { id: 202, chineseName: '印尼剧2', episodeName: 'Indo Drama 2', playCount: '31.5万', isTop: true, sort: 2 },
                    { id: 203, chineseName: '印尼剧3', episodeName: 'Indo Drama 3', playCount: '26.8万', isTop: false, sort: 3 },
                ],
                japanese: [
                    { id: 301, chineseName: '日剧1', episodeName: 'Japan Drama 1', playCount: '55.3万', isTop: true, sort: 1 },
                    { id: 302, chineseName: '日剧2', episodeName: 'Japan Drama 2', playCount: '48.7万', isTop: true, sort: 2 },
                    { id: 303, chineseName: '日剧3', episodeName: 'Japan Drama 3', playCount: '39.2万', isTop: true, sort: 3 },
                    { id: 304, chineseName: '日剧4', episodeName: 'Japan Drama 4', playCount: '33.6万', isTop: false, sort: 4 },
                ],
                korean: [
                    { id: 401, chineseName: '韩剧1', episodeName: 'Korea Drama 1', playCount: '62.5万', isTop: true, sort: 1 },
                    { id: 402, chineseName: '韩剧2', episodeName: 'Korea Drama 2', playCount: '51.8万', isTop: true, sort: 2 },
                    { id: 403, chineseName: '韩剧3', episodeName: 'Korea Drama 3', playCount: '44.2万', isTop: false, sort: 3 },
                ],
                brazilian: [
                    { id: 501, chineseName: '巴西剧1', episodeName: 'Brazil Drama 1', playCount: '28.3万', isTop: true, sort: 1 },
                    { id: 502, chineseName: '巴西剧2', episodeName: 'Brazil Drama 2', playCount: '22.1万', isTop: false, sort: 2 },
                    { id: 503, chineseName: '巴西剧3', episodeName: 'Brazil Drama 3', playCount: '19.5万', isTop: false, sort: 3 },
                ],
            }
        }
    },
    mounted() {
        this.getLanguageList()
    },
    methods: {
        // 格式化播放量，超过一万单位显示为万
        formatPlayCount(count) {
            if (count >= 10000) {
                return (count / 10000).toFixed(2) + '万'
            }
            return count
        },
        // 获取语言列表
        getLanguageList() {
            this.loading = true
            getLangList({ current: -1, size: -1 }).then((r) => {
                if (r.code === 200) {
                    const data = r.data.records || []
                    data.forEach(item => {
                        item.label = item.chineseLangName||item.langName
                        item.value = item.id.toString()
                    })
                    this.tabs = data
                    this.activeTab = data[0].id.toString()
                    this.loadData()
                }
            })
        },
        loadData() {
            this.loading = true
            getMinisForUPage({
                current: this.pageObj.current,
                size: this.pageObj.size,
                countryId: this.activeTab,
                playIds: this.playIds
            }).then((r) => {
                if (r.code === 200) {
                    const data = r.data.records || []
                    this.currentData = data
                    this.pageObj.total = r.data.total || 0
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handleTabChange() {
            this.pageObj.current = 1
            this.palsyName = ''
            this.playIds = ''
            this.$refs.playRef.handleReset()
            this.loadData()
        },
        handleLanguageChange(name) {
            this.activeLanguage = name
            this.pageObj.current = 1
            this.palsyName = ''
            this.loadData()
        },
        handleSearch() {
            this.loadData()
        },
        handleReset() {
            this.palsyName = ''
            this.pageObj.current = 1
            this.playIds = ''
            this.$refs.playRef.handleReset()
            this.loadData()
        },
        handlePageChange(page) {
            this.pageObj.current = page || 1
            this.loadData()
        },
        handleTop(row) {
            updateMinisForUUpdate({updateList:[{
                id: row.id,
                istop: row.istop === 1 ? 0 : 1
            }]}).then((r) => {
                if (r.code === 200) {
                    this.$Message.success('操作成功')
                } else {
                    this.$Message.error(r.message || '操作失败')
                }
                this.loadData()
            })
        },
        handleDragEnd(evt) {
            let arr=[]
            for(let i=0;i<this.currentData.length;i++){
                if(this.currentData[i].istop===1){
                    arr.push({
                    id: this.currentData[i].id,
                    sort: i+1
                })
                }
            }
            // 更新排序
            updateMinisForUUpdate({
                updateList: arr
            }).then((r) => {
                if (r.code === 200) {
                    this.loadData()
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.for-u-container {
    min-height: calc(100vh - 100px);
}

.search {
    display: flex;
    align-items: center;
    margin: 20px 0;
    gap: 8px;
}

.table-container {
    position: relative;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}

.loading-spinner {
    width: 36px;
    height: 36px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #409eff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 1px solid #ebeef5;
}

.custom-table th,
.custom-table td {
    padding: 12px 16px;
    font-size: 14px;
    border: 1px solid #ebeef5;
}

.custom-table th {
    background-color: #fafafa;
    font-weight: 600;
    color: #303133;
    text-align: left;
    border-right: 1px solid #ebeef5;
}

.custom-table th:last-child {
    border-right: none;
}

.custom-table td {
    color: #303133;
    border-right: 1px solid #ebeef5;
}

.custom-table td:last-child {
    border-right: none;
}

.custom-table tr:hover {
    background-color: #fafafa;
}

.col-drag {
    width: 100px;
    text-align: center;
}

.col-top {
    width: 100px;
    text-align: center;
}

.col-chinese-name {
    min-width: 120px;
    .btn-tag{
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        color: #f56c6c;
        background-color: #fef0f0;
        border: 1px solid rgb(250, 182, 182);
        margin-right: 4px;
    }
}

.col-episode-name {
    min-width: 150px;
}

.col-play-count {
    width: 130px;
    font-weight: 600;
}

.drag-icon {
    cursor: move;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    &:hover {
        color: #409eff;
    }
}

.empty-drag {
    display: inline-block;
    width: 20px;
    height: 20px;
}

.pagination {
    margin-top: 16px;
    text-align: right;
}

.sortable-ghost {
    background-color: #e6f7ff !important;
    opacity: 0.8;
}
.no-data {
  width: 100%;
  height: 48px;
  text-align: center;
  padding: 20px 0;
  color: #515a6e;
}
</style>
